export const properties = {
    host: process.env.REACT_APP_API_BASE || "http://localhost:8080",
    google: {
        clientId: "271547686743-bfssigv25gqauasdpvvsjb8n61v9kv0k.apps.googleusercontent.com"
    }
}